import { render, staticRenderFns } from "./CameraImageCapture.vue?vue&type=template&id=f6d399a4&scoped=true&"
import script from "./CameraImageCapture.vue?vue&type=script&lang=js&"
export * from "./CameraImageCapture.vue?vue&type=script&lang=js&"
import style0 from "./CameraImageCapture.vue?vue&type=style&index=0&id=f6d399a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d399a4",
  null
  
)

export default component.exports